import styled from "styled-components"
import { Theme } from "./theme"

export const DropdownTitle = styled.p`
  color: ${Theme.colors.gray1};
  font-family: "MikroMedium";
`
